import { ThirdPartyOrderStatus } from "react-migration/domains/sites/components/SiteCard/ReportSidebar/AiDash/hooks/useThirdPartyOrder";

export const calculateDaysOverdue = (dueDateISO: string, reportStatus: ThirdPartyOrderStatus | null) => {
  if (
    reportStatus === ThirdPartyOrderStatus.FAILED ||
    reportStatus === ThirdPartyOrderStatus.CANCELED ||
    reportStatus === ThirdPartyOrderStatus.COMPLETED
  ) {
    return {
      daysOverdue: null,
      isOverdue: false,
    };
  }
  const dueDate = new Date(dueDateISO).getTime();
  const currentDate = new Date().getTime();
  const diffInMs = currentDate - dueDate;
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return {
    daysOverdue: diffInDays > 0 ? `${diffInDays} day${diffInDays > 1 ? "s" : ""} ` : "",
    isOverdue: diffInMs > 0,
  };
};
